import { v4 as uuidv4 } from 'uuid';
import $ from 'jquery';
/* eslint max-lines: ["error", 500] */
export default [
	'$http',
	'$timeout',
	function ($http, $timeout) {
		const THANK_YOU_SUCCESS_MESSAGE_CLASS = '.success-message';
		const SCROLL_SPEED_IN_MILLISECOND = 1000;
		const LEGACY_USER_TYPE = {
			MOBILE_POSTPAID: 'MOBILE_POSTPAID',
			HOME: 'HOME',
			MOBILE_PREPAID: 'MOBILE_PREPAID'
		};
		let proxyPrefix = '/dynaform/api';
		let factory = {};
		const arrayToParams = (name, array, url) => {
			array.forEach((item) => {
				url.append(name, item);
			});
		};
		function getFormPostUrl(formName, sessionId) {
			// MT specific
			let path = window.location.pathname.substring(1);
			let slashIndex = path.indexOf('/');
			let firstPathSegment = '';
			sessionId = new Date().getTime();
			firstPathSegment = slashIndex != -1 ? `/${path.substring(0, slashIndex)}` : firstPathSegment;

			return `${firstPathSegment}${proxyPrefix}/requests/forms/${formName}/sessions/${sessionId}/complete`;
		}

		function mtIdAlreadyContaining(legacyUsersData, concatedMtId) {
			return legacyUsersData.find((element) => {
				return element.mtId == concatedMtId;
			});
		}

		function getUserData(legacyUsersData, userData, mtId) {
			if (userData.name.naturalPerson && !mtIdAlreadyContaining(legacyUsersData, mtId)) {
				legacyUsersData.push({ name: userData.name.fullName, mtId: mtId, phoneNumber: userData.msisdn });
			}

			return legacyUsersData;
		}

		factory.sendForm = function (data, formName, sessionId, cb) {
			$http.post(getFormPostUrl(formName, sessionId), data).then(cb, cb);
		};

		factory.getMtUserDataFormInputs = function ({ type, productCategories, excludedProductCategories }) {
			const urlSearchparams = new URLSearchParams();
			if (type) {
				urlSearchparams.append('type', type);
			}
			if (productCategories?.length) {
				arrayToParams('includedCategories', productCategories, urlSearchparams);
			}
			if (excludedProductCategories?.length) {
				arrayToParams('excludedCategories', excludedProductCategories, urlSearchparams);
			}
			return $http({
				method: 'GET',
				url: `/portal/api/dynaform/asset-details?${urlSearchparams.toString()}`,
				headers: {
					'Content-Type': 'application/json',
					'x-correlation-id': uuidv4(),
					'x-request-id': uuidv4()
				}
			});
		};
		factory.getMtUserDataFormInputsLegacy = function () {
			return $http.get('/telekomfiok/relevant_users_v5');
		};
		factory.getMtContactDataFormInputs = function () {
			return $http({
				method: 'GET',
				url: '/portal/api/dynaform/identifiers',
				headers: {
					'Content-Type': 'application/json',
					'x-correlation-id': uuidv4(),
					'x-request-id': uuidv4()
				}
			});
		};
		factory.getSubscriberList = function (legacyUsers) {
			let legacyUsersData = [];
			if (!legacyUsers || legacyUsers.length == 0) {
				return legacyUsersData;
			}

			legacyUsers.forEach((legacyUser) => {
				switch (legacyUser.legacyUserType) {
					case LEGACY_USER_TYPE.MOBILE_POSTPAID:
						legacyUsersData = getUserData(legacyUsersData, legacyUser.postpaidUser, legacyUser.postpaidUser.payerMtid);
						break;
					case LEGACY_USER_TYPE.MOBILE_PREPAID:
						legacyUsersData = getUserData(legacyUsersData, legacyUser.prepaidUser, legacyUser.prepaidUser.subscriberMtid);
						break;
					case LEGACY_USER_TYPE.HOME:
						legacyUsersData = getUserData(legacyUsersData, legacyUser.homeUser, legacyUser.homeUser.mtid);
						break;
					default:
						break;
				}
			});
			return legacyUsersData;
		};

		/**
		 * @param inputId: design select shiwa által generált id-ja
		 * @param phoneArea
		 * @returns {boolean}: eldönti, hogy a selectben bevan-e szerkesztve az a phoneArea, amit prefillelni kell
		 */
		function designSelectContainPhoneArea(inputId, phoneArea) {
			let options = angular.element(`[name="${inputId}_select"] > option`);
			for (let i = 0; i < options.length; i++) {
				if (options[i].value.indexOf(phoneArea) > -1) {
					return true;
				}
			}
			return false;
		}

		factory.getPhoneNumberFromMtUserData = function (inputId, selectedPhoneNumber) {
			if (!selectedPhoneNumber) {
				return { phoneArea: 30, phoneNumber: '' };
			}

			let radix = 10;
			let phoneArea = parseInt(selectedPhoneNumber.substring(2, 4), radix);
			let phoneNumber = selectedPhoneNumber.substring(4, selectedPhoneNumber.length);
			let selectIsContainPhoneArea = designSelectContainPhoneArea(inputId, phoneArea);

			return { phoneArea: selectIsContainPhoneArea ? phoneArea : undefined, phoneNumber: parseInt(phoneNumber) };
		};

		function animateTo(elem) {
			let viewPortHeight = window.innerHeight || 0;

			$('html, body').animate(
				{
					scrollTop: Math.ceil(elem.offset().top - viewPortHeight / 2)
				},
				SCROLL_SPEED_IN_MILLISECOND
			);
		}

		function scrollToElementIfNeed($element) {
			let elementOffset = $element.offset().top;
			let elementHeight = $element.height();
			if (elementHeight < elementOffset) {
				animateTo($element);
			}
		}

		factory.scrollToThankYouContent = function () {
			$timeout(function () {
				let $messageSelector = $(THANK_YOU_SUCCESS_MESSAGE_CLASS);
				if ($messageSelector.length) {
					scrollToElementIfNeed($messageSelector);
				}
			});
		};

		return factory;
	}
];
